// ImageCarousel.jsx
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './ImageCarousel.module.css';

const ImageCarousel = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  return (
    <div className={styles.carouselContainer}>
      <div className={styles.imageWrapper}>
        <AnimatePresence mode='wait'>
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
            className={styles.slideContent}
          >
            {/* In real app, use <img src={slides[currentIndex].img} /> */}
    
                <div className={styles.mockScreenshot}>
                <div className={styles.browserHeader}>
                    <span className={styles.dot}></span><span className={styles.dot}></span><span className={styles.dot}></span>
                </div>
                <div className={styles.imageContainer}>
                    {/* REPLACE THE MOCK BODY WITH THIS */}
                    <img 
                    src={slides[currentIndex].imgUrl} 
                    alt={slides[currentIndex].title} 
                    className={styles.realScreenshot} 
                    />
                </div>
                </div>
          </motion.div>
        </AnimatePresence>
      </div>
      
      <button className={styles.navBtnLeft} onClick={prevSlide}>
        <ChevronLeft size={24} />
      </button>
      <button className={styles.navBtnRight} onClick={nextSlide}>
        <ChevronRight size={24} />
      </button>

      <div className={styles.indicators}>
        {slides.map((_, index) => (
          <span 
            key={index} 
            className={`${styles.indicator} ${index === currentIndex ? styles.activeIndicator : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;